// Vuetify
import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { createVuetify } from "vuetify";
//import { VDataTable } from "vuetify/labs/VDataTable";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import * as labsComponents from "vuetify/labs/components";

const savedTheme = localStorage.getItem("aom-theme") || "light";

const vuetify = createVuetify({
	theme: {
		defaultTheme: savedTheme,
		themes: {
			light: {
				dark: false,
				colors: {
					primary: "#1e7c73",
					"primary-lighten-1": "#30a59d",
					"primary-darken-1": "#1e5c58",
					error: "#AE2424",
					background: "#f1f5f9",
					surface: "#ffffff",
				},
			},
			dark: {
				dark: true,
				colors: {
					primary: "#30a59d",
					"primary-lighten-1": "#4dc4bb",
					"primary-darken-1": "#1e7c73",
					error: "#cf4444",
					background: "#0d1117",
					surface: "#161b22",
				},
			},
		},
	},
	components: {
		//VDataTable,
		...components,
		...labsComponents,
	},
	directives,
});

export default vuetify;
